/* ============================================================================
   PrimeStyle 2026 COLLECTION BROWSER — behaviour
   ----------------------------------------------------------------------------
   Pairs with snippets/ps-col26-shelves.liquid (markup + window.PS_SHELVES) and
   assets/ps-col26-shelves.css. Runs on a hub page after the shared collection shell
   (ps-collection26.js) has booted: the shell exposes window.PSCol26 — the parent feed,
   the approved card renderer and the metal-swap routine — and fires 'ps:col26'.

   What it does
   - Fetches one small membership feed per named section (templates/collection.col26-ids,
     every page of it, three requests at a time, retried with backoff), and fills each
     section with the PARENT feed's products that belong to it, in the parent's order.
     A product may sit in several sections; never twice in one.
   - An `own` section (a menu collection that shares nothing with the parent, e.g. the fancy
     bridal sets on the Colored Diamonds hub) shows that collection's OWN data feed instead,
     and hands its products to the shell's Favorite Picks (PSCol26.renderPicks) and to the
     hero figure marked data-live.
   - "More from the collection" = parent products no named section claimed.
   - Empty sections (and their directory entries) are removed; numbering stays consecutive.
   - One row per section at the current width. VIEW MORE adds one more row to that section
     only; Show less returns it to one row, scrolls its heading under the sticky chrome
     and hands focus back to VIEW MORE. Resizing re-fits unexpanded sections only.
   - Directory / selector navigation, current-section highlighting on scroll, deep links,
     and the category pills above re-pointed at their matching sections.
   - Sticky offsets are measured from the real header, never hard-coded.
   ========================================================================== */
(function(){
  'use strict';
  var root = document.querySelector('.cbrowse');
  if (!root || root.__psShelves) return;
  root.__psShelves = true;

  var CONF = window.PS_SHELVES || [];
  var CFG = window.PS_PAGE || {};
  var host = document.getElementById('collection-sections');
  var nav = document.getElementById('collection-nav');
  var jump = document.getElementById('collection-jump');
  var status = document.getElementById('cb-status');
  var mobile = root.querySelector('.collection-mobile');
  var dirBox = root.querySelector('.directory-inner');
  var bar = document.getElementById('ps-sticky');
  var reduced = function(){ return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };
  function say(text){ if (!status) return; status.textContent = ''; status.textContent = text; }
  function esc(s){ return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  /* ---- sticky offsets, measured (the condensed header is a fixed bar; the selector
     is sticky under it on tablet/phone) ---- */
  function offsets(){
    var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    root.style.setProperty('--cb-stick', h + 'px');
    var s = (mobile && getComputedStyle(mobile).display !== 'none') ? Math.round(mobile.getBoundingClientRect().height) : 0;
    root.style.setProperty('--cb-select', s + 'px');
  }
  offsets();
  window.addEventListener('resize', offsets);
  if (window.ResizeObserver) {
    var ro0 = new ResizeObserver(offsets);
    if (bar) ro0.observe(bar);
    if (mobile) ro0.observe(mobile);
  }

  /* ---- the sections as declared by the snippet ---- */
  var shelves = [];
  CONF.forEach(function(c){
    var el = document.getElementById('section-' + c.handle);
    if (!el) return;
    shelves.push({
      cfg: c, el: el,
      grid: el.querySelector('.shelf-grid'),
      more: el.querySelector('.shelf-more'),
      less: el.querySelector('.shelf-less'),
      prog: el.querySelector('.shelf-progress'),
      note: el.querySelector('.shelf-note'),
      title: el.querySelector('h3'),
      items: null, shown: 0, expanded: false, settled: false, failed: false, removed: false, loading: false, ids: null
    });
  });
  if (!shelves.length) return;
  root.__psShelfState = shelves;   /* read-only view for the verification harness */
  /* Compare (owner review 2026-09-10, C-01): the shell owns the tray and the modal;
     the shelves only forward the card button, wherever the card sits on the page. */
  if (host) host.addEventListener('click', function(e){
    var b = e.target.closest('.pcard-compare');
    if (!b) return;
    var API = window.PSCol26;
    if (API && API.compare) API.compare.toggle(b.getAttribute('data-id'));
  });
  var links = {};
  if (nav) nav.querySelectorAll('a[data-target]').forEach(function(a){ links[a.getAttribute('data-target')] = a; });
  function live(){ return shelves.filter(function(s){ return !s.removed; }); }
  function byHandle(h){ for (var i = 0; i < shelves.length; i++) if (!shelves[i].removed && shelves[i].cfg.handle === h) return shelves[i]; return null; }

  /* ---- navigation works before any product loads: the headings are server-rendered ---- */
  function go(handle, focusHeading){
    var s = byHandle(handle);
    if (!s) return;
    s.el.scrollIntoView({block: 'start', behavior: reduced() ? 'auto' : 'smooth'});
    if (window.history && window.history.replaceState) window.history.replaceState(null, '', '#section-' + handle);
    if (focusHeading && s.title) s.title.focus({preventScroll: true});
  }
  if (nav) nav.addEventListener('click', function(e){
    var a = e.target.closest('a[data-target]');
    if (!a) return;
    e.preventDefault();
    go(a.getAttribute('data-target'), true);
  });
  if (jump) jump.addEventListener('change', function(){ go(jump.value, false); });

  /* ---- current section follows the scroll ---- */
  var pending = false;
  function keepVisible(a){
    if (!a || !dirBox || dirBox.scrollHeight <= dirBox.clientHeight) return;
    var r = a.getBoundingClientRect(), b = dirBox.getBoundingClientRect();
    if (r.top < b.top) dirBox.scrollTop += r.top - b.top - 8;
    else if (r.bottom > b.bottom) dirBox.scrollTop += r.bottom - b.bottom + 8;
  }
  function active(){
    pending = false;
    var list = live();
    if (!list.length) return;
    var line = window.innerHeight * 0.35, cur = list[0];
    list.forEach(function(s){ if (s.el.getBoundingClientRect().top <= line) cur = s; });
    list.forEach(function(s){
      var a = links[s.cfg.handle];
      if (!a) return;
      if (s === cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    if (jump && jump.value !== cur.cfg.handle) jump.value = cur.cfg.handle;
    keepVisible(links[cur.cfg.handle]);
  }
  window.addEventListener('scroll', function(){ if (!pending) { pending = true; requestAnimationFrame(active); } }, {passive: true});

  /* ---- everything below needs the shell (parent feed + card renderer) ---- */
  function boot(){
    var API = window.PSCol26;
    if (!API || root.__psBooted) return;
    root.__psBooted = true;
    /* The shell now boots on the FIRST feed page (48 products, 2026-09-09) and merges the
       rest behind it; the parent feed this browser matches ids against has to be the
       whole one, so wait for PSCol26.ready (already settled on a one-page collection). */
    var ready = API.ready && typeof API.ready.then === 'function' ? API.ready : Promise.resolve();
    ready.then(function(){ run(API); }, function(){ run(API); });
  }
  function run(API){
    var PRODUCTS = API.products || [];

    /* the parent feed came up short: say so once, above the sections */
    var feed = window.PS_COLLECTION && window.PS_COLLECTION.feed;
    if ((feed && feed.failed && feed.failed.length) || !PRODUCTS.length) {
      var notice = document.createElement('div');
      notice.className = 'shelf-note';
      notice.setAttribute('role', 'status');
      notice.innerHTML = '<span>' + (PRODUCTS.length
        ? 'Only ' + PRODUCTS.length + ' of ' + feed.expected + ' pieces loaded, so some sections may be short.'
        : 'The collection did not load.') + '</span><button type="button">Try again</button>';
      notice.querySelector('button').addEventListener('click', function(){ window.location.reload(); });
      host.insertBefore(notice, host.firstChild);
    }

    function cols(s){
      var cs = getComputedStyle(s.grid).gridTemplateColumns;
      var rep = /^repeat\((\d+)/.exec(cs);
      if (rep) return Math.max(1, parseInt(rep[1], 10));
      if (!cs || cs === 'none') return 1;
      return Math.max(1, cs.split(' ').filter(Boolean).length);
    }
    function counts(s){
      var n = s.items ? s.items.length : 0;
      s.el.querySelectorAll('[data-count]').forEach(function(el){ el.textContent = n + (n === 1 ? ' design' : ' designs'); });
      var a = links[s.cfg.handle];
      if (a) { var c = a.querySelector('[data-count]'); if (c) c.textContent = n; }
      if (jump) {
        var o = jump.querySelector('option[value="' + s.cfg.handle + '"]');
        if (o) o.textContent = s.cfg.label + ' (' + n + ')';
      }
    }
    function sync(s){
      var total = s.items.length, all = s.shown >= total;
      s.prog.textContent = 'Showing ' + s.shown + ' of ' + total;
      s.more.hidden = all;
      s.more.setAttribute('aria-expanded', String(s.expanded));
      s.more.setAttribute('aria-label', 'View more ' + s.cfg.label.toLowerCase());
      s.less.hidden = !s.expanded;
      s.grid.setAttribute('aria-busy', 'false');
      counts(s);
    }
    function append(s, n){
      var next = s.items.slice(s.shown, s.shown + n);
      if (!next.length) { sync(s); return 0; }
      var frag = document.createElement('div');
      var cmp = !!(API.compare && document.getElementById('cg-ctray'));
      if (cmp) next.forEach(function(p){ API.compare.register(p); });
      frag.innerHTML = next.map(function(p){ return API.cardHTML(p, {compare: cmp}); }).join('');
      repriceAll(frag);
      while (frag.firstChild) s.grid.appendChild(frag.firstChild);
      s.shown += next.length;
      if (cmp && API.compare.sync) API.compare.sync();
      if (API.hydrate) API.hydrate(s.grid);
      sync(s);
      return next.length;
    }
    function trim(s, n){
      while (s.grid.children.length > n) s.grid.lastElementChild.remove();
      s.shown = s.grid.children.length;
      sync(s);
    }
    function showNote(s, text, retry){
      s.note.innerHTML = '<span>' + esc(text) + '</span>' + (retry ? '<button type="button">Try again</button>' : '');
      s.note.hidden = false;
      if (retry) s.note.querySelector('button').addEventListener('click', function(){ load(s); });
    }
    function clearNote(s){ s.note.hidden = true; s.note.innerHTML = ''; }
    function renumber(){
      live().forEach(function(s, i){
        var n = s.el.querySelector('.shelf-number');
        if (n) n.textContent = String(i + 1).padStart(2, '0');
      });
    }
    function remove(s){
      s.removed = true;
      s.el.remove();
      var a = links[s.cfg.handle];
      if (a) { a.remove(); delete links[s.cfg.handle]; }
      if (jump) { var o = jump.querySelector('option[value="' + s.cfg.handle + '"]'); if (o) o.remove(); }
      /* a group with no links left, or an emptied optgroup, goes too */
      if (nav) nav.querySelectorAll('.directory-group').forEach(function(g){
        var nx = g.nextElementSibling;
        if (!nx || !nx.matches('a')) g.remove();
      });
      if (jump) jump.querySelectorAll('optgroup').forEach(function(og){ if (!og.querySelector('option')) og.remove(); });
      renumber();
    }
    function render(s){
      clearNote(s);
      s.grid.innerHTML = '';
      s.shown = 0; s.expanded = false;
      append(s, cols(s));
    }
    /* Owner review 2026-09-10 (C-01 / C-11): a shelf is the sub-collection's pieces ON
       THIS parent, and that intersection can be thinner than a row (hoop & drop: 3 on
       the earrings hub, 14 in its own collection) while the collection page itself
       is full. When the intersection cannot fill a desktop row, the shelf tops up
       from the sub-collection's own feed, keeping the parent's origin (a natural hub
       never borrows lab pieces and vice versa) and never repeating a card. */
    var FILL = 4;
    function parentOrigin(){
      var n = 0, lab = 0;
      PRODUCTS.forEach(function(p){ n++; if (p.origin === 'lab') lab++; });
      if (!n) return null;
      return lab === n ? 'lab' : (lab === 0 ? 'natural' : null);
    }
    function settle(s, ids){
      var set = {}, seen = {}, items = [];
      (ids || []).forEach(function(id){ set[String(id)] = 1; });
      PRODUCTS.forEach(function(p){
        var k = String(p.id);
        if (set[k] && !seen[k]) { seen[k] = 1; items.push(p); }
      });
      /* the membership feed says how many pieces the sub-collection really has; when
         the parent shelf holds fewer of them than that (the bracelets hub's parent
         carries 19 of the 64 tennis bracelets), or fewer than a row, the rest come
         from the sub-collection's own feed */
      var members = (ids || []).length;
      /* a facet hub (one shape, one price band, one carat band) is the intersection and
         nothing else: PS_PAGE.shelfTopUp === false keeps a shelf inside the facet */
      var topUp = !(CFG && CFG.shelfTopUp === false);
      if (topUp && !s.cfg.own && (items.length < FILL || items.length < members)) {
        var want = parentOrigin();
        return loadOwn(s).then(function(products){
          (products || []).forEach(function(p){
            var k = String(p.id);
            if (seen[k]) return;
            if (want && p.origin && p.origin !== want) return;
            seen[k] = 1; items.push(p); byId[k] = p;
          });
          finish(s, seen, items);
        }, function(){ finish(s, seen, items); });
      }
      finish(s, seen, items);
    }
    function finish(s, seen, items){
      if (s.cfg.shape) items = items.filter(function(p){ return p.shape === s.cfg.shape; });
      s.ids = seen; s.items = items; s.settled = true; s.failed = false; s.loading = false;
      if (!items.length) remove(s); else render(s);
      afterSettle();
    }
    /* an own-feed section: its products are the feed's, in the feed's order, deduplicated */
    var ownFed = {};
    function settleOwn(s, products){
      var seen = {}, items = [];
      (products || []).forEach(function(p){
        var k = String(p.id);
        if (!seen[k]) { seen[k] = 1; items.push(p); byId[k] = p; }
      });
      s.ids = seen; s.items = items; s.settled = true; s.failed = false; s.loading = false;
      if (!items.length) remove(s); else render(s);
      /* the picks row and the hero figure learn about these pieces once per section */
      if (items.length && !ownFed[s.cfg.handle]) {
        ownFed[s.cfg.handle] = 1;
        if (API.renderPicks) API.renderPicks(items);
        heroTotal();
      }
      afterSettle();
    }
    function heroTotal(){
      var el = document.getElementById('hero-count');
      if (!el || !el.hasAttribute('data-live')) return;
      var n = PRODUCTS.length;
      shelves.forEach(function(s){ if (s.cfg.own && s.items) n += s.items.length; });
      if (n) el.textContent = String(n);
    }
    function fail(s){
      s.settled = true; s.failed = true; s.loading = false;
      s.grid.setAttribute('aria-busy', 'false');
      s.prog.textContent = '';
      s.el.querySelectorAll('[data-count]').forEach(function(el){ el.textContent = 'Not loaded'; });
      showNote(s, 'This collection did not load.', true);
      afterSettle();
    }

    /* ---- membership feeds: three at a time, every page, backoff on 429 / 5xx ---- */
    var MAX = 3, activeReq = 0, queue = [];
    function pump(){
      while (activeReq < MAX && queue.length) {
        var job = queue.shift();
        activeReq++;
        job().then(function(){ activeReq--; pump(); }, function(){ activeReq--; pump(); });
      }
    }
    function getJSON(url, attempt){
      return fetch(url, {credentials: 'same-origin'}).then(function(r){
        if (r.status === 429 || r.status >= 500) {
          var ra = Number(r.headers.get('Retry-After')) || 0;
          var err = new Error('HTTP ' + r.status); err.retry = true; err.wait = ra * 1000; throw err;
        }
        if (!r.ok) { var e2 = new Error('HTTP ' + r.status); e2.status = r.status; throw e2; }
        return r.json();
      }).catch(function(err){
        if (err && err.status === 404) throw err;
        if (attempt < 3) {
          var wait = (err && err.wait) || 900 * (attempt + 1);
          return new Promise(function(res){ setTimeout(res, wait); }).then(function(){ return getJSON(url, attempt + 1); });
        }
        throw err;
      });
    }
    function pageUrl(src, n){ return n > 1 ? src + '&page=' + n : src; }
    function readIds(d){
      if (d && d.ids) return {ids: d.ids, pages: d.pages || 1};
      /* the full data feed answers the same question when the ids template is absent */
      if (d && d.products) return {ids: d.products.map(function(p){ return p.id; }), pages: (d.collection && d.collection.pages) || 1};
      throw new Error('not a membership feed');
    }
    function loadIds(s){
      var src = s.cfg.src;
      return getJSON(pageUrl(src, 1), 0).catch(function(err){
        if (!(err && err.status === 404)) throw err;
        if (window.console) console.warn('PS shelves: col26-ids template missing for ' + s.cfg.handle + ', reading the full feed instead.');
        src = src.replace('view=col26-ids', 'view=col26-data');
        return getJSON(pageUrl(src, 1), 0);
      }).then(function(first){
        var r = readIds(first), ids = r.ids.slice();
        if (r.pages <= 1) return ids;
        var rest = [];
        for (var n = 2; n <= r.pages; n++) rest.push(getJSON(pageUrl(src, n), 0).then(readIds));
        return Promise.all(rest).then(function(more){
          more.forEach(function(m){ ids = ids.concat(m.ids); });
          return ids;
        });
      });
    }
    function loadOwn(s){
      var src = s.cfg.src.replace('view=col26-ids', 'view=col26-data');
      return getJSON(pageUrl(src, 1), 0).then(function(first){
        var products = (first && first.products) || [];
        var pages = (first && first.collection && first.collection.pages) || 1;
        if (pages <= 1) return products;
        var rest = [];
        for (var n = 2; n <= pages; n++) rest.push(getJSON(pageUrl(src, n), 0).then(function(d){ return (d && d.products) || []; }));
        return Promise.all(rest).then(function(more){
          more.forEach(function(m){ products = products.concat(m); });
          return products;
        });
      });
    }
    function load(s){
      if (s.loading) return;         /* one request per section at a time */
      s.loading = true;
      clearNote(s);
      s.grid.setAttribute('aria-busy', 'true');
      s.prog.textContent = 'Loading designs';
      queue.push(function(){
        return s.cfg.own
          ? loadOwn(s).then(function(products){ settleOwn(s, products); }, function(){ fail(s); })
          : loadIds(s).then(function(ids){ settle(s, ids); }, function(){ fail(s); });
      });
      pump();
    }

    /* ---- the closing section: whatever no named section claimed ---- */
    var restShelf = shelves.filter(function(s){ return s.cfg.rest; })[0];
    var linked = false;
    function afterSettle(){
      var named = shelves.filter(function(s){ return !s.cfg.rest; });
      if (!named.every(function(s){ return s.settled; })) return;
      if (restShelf && !restShelf.removed) {
        var covered = {};
        named.forEach(function(s){ if (s.ids) Object.keys(s.ids).forEach(function(k){ covered[k] = 1; }); });
        var items = PRODUCTS.filter(function(p){ return !covered[String(p.id)]; });
        var same = restShelf.items && restShelf.items.length === items.length && restShelf.items.every(function(p, i){ return p === items[i]; });
        if (!items.length) remove(restShelf);
        else if (!same) { restShelf.items = items; restShelf.settled = true; render(restShelf); }
        if (restShelf && !restShelf.removed) {
          if (named.some(function(s){ return s.failed; })) showNote(restShelf, 'Some collections did not load, so their pieces may appear here for now.', false);
          else clearNote(restShelf);
        }
      }
      if (!linked) {
        linked = true;
        /* the category pills above the browser jump to their matching section */
        document.querySelectorAll('.relpill[href]').forEach(function(a){
          var m = /\/collections\/([^/?#]+)/.exec(a.getAttribute('href') || '');
          if (!m || !byHandle(m[1])) return;
          var handle = m[1];
          a.setAttribute('href', '#section-' + handle);
          a.addEventListener('click', function(e){ e.preventDefault(); go(handle, true); });
        });
        /* a deep link into a section lands on the heading, under the sticky chrome */
        var h = /^#section-([\w-]+)$/.exec(window.location.hash || '');
        if (h && byHandle(h[1])) requestAnimationFrame(function(){ document.getElementById('section-' + h[1]).scrollIntoView({block: 'start', behavior: 'auto'}); });
      }
      active();
    }

    /* ---- controls ---- */
    shelves.forEach(function(s){
      s.more.addEventListener('click', function(){
        append(s, cols(s));
        s.expanded = true;
        sync(s);
        say('Showing ' + s.shown + ' of ' + s.items.length + ' ' + s.cfg.label.toLowerCase() + '.');
        if (s.more.hidden) s.less.focus({preventScroll: true});
      });
      s.less.addEventListener('click', function(){
        trim(s, cols(s));
        s.expanded = false;
        sync(s);
        s.el.scrollIntoView({block: 'start', behavior: reduced() ? 'auto' : 'smooth'});
        s.more.focus({preventScroll: true});
        say(s.cfg.label + ' collapsed to one row, showing ' + s.shown + ' of ' + s.items.length + '.');
      });
    });
    /* The price follows the chosen metal (brief: "actual configuration price"). The feed
       carries each orderable color's starting price in `metals`; platinum shares the white
       photograph but keeps its own price. A swatch's data-color is the PHOTO key, so the
       metal is read from its label. Cards without `metals` keep the base price. */
    var byId = {};
    PRODUCTS.forEach(function(p){ byId[String(p.id)] = p; });
    function metalKey(md){
      var t = (md.getAttribute('title') || '').toLowerCase();
      return /platinum/.test(t) ? 'platinum' : /yellow/.test(t) ? 'yellow' : /rose/.test(t) ? 'rose' : 'white';
    }
    function reprice(card, md){
      if (!API.priceHTML || !card || !md) return;
      var p = byId[card.getAttribute('data-id')];
      var cfg = p && p.metals && p.metals[metalKey(md)];
      var price = card.querySelector('.price');
      if (cfg && price) price.outerHTML = API.priceHTML(p, cfg);
    }
    function repriceAll(grid){
      grid.querySelectorAll('.pcard').forEach(function(card){ reprice(card, card.querySelector('.mdot.is-sel')); });
    }
    /* metal swatches and the wishlist heart behave exactly as on the shell's grid */
    host.addEventListener('click', function(e){
      var md = e.target.closest('.mdot');
      if (md) { e.preventDefault(); var card = md.closest('.pcard'); API.selectMetal(card, md); reprice(card, md); return; }
      var wish = e.target.closest('.pcard-wish');
      /* the shelves used the same cosmetic toggle as the grid; one shared handler
         now does the real save for both */
      if (wish) { if (API.wishToggle) API.wishToggle(wish); else { var on = wish.classList.toggle('is-on'); wish.setAttribute('aria-pressed', String(on)); } }
    });
    /* resizing: an unexpanded section always shows one row at the new width; an
       expanded one keeps what it revealed and its next VIEW MORE uses the new row size */
    var rt = false;
    function refit(){
      rt = false;
      live().forEach(function(s){
        if (!s.items || s.expanded) return;
        var n = cols(s);
        if (n > s.shown) append(s, n - s.shown);
        else if (n < s.shown) trim(s, n);
      });
    }
    if (window.ResizeObserver) new ResizeObserver(function(){ if (!rt) { rt = true; requestAnimationFrame(refit); } }).observe(host);
    else window.addEventListener('resize', function(){ if (!rt) { rt = true; requestAnimationFrame(refit); } });

    shelves.forEach(function(s){ if (!s.cfg.rest) load(s); });
    if (!shelves.some(function(s){ return !s.cfg.rest; })) afterSettle();
  }

  if (window.PSCol26) boot();
  else document.addEventListener('ps:col26', boot, {once: true});
})();
